import { clearApiCache } from "../../../app/api";

const TOKEN_KEY = "token";
const INN_KEY = "inn";
const FIRST_NAME_KEY = "firstName";
const LAST_NAME_KEY = "lastName";

const setToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

const setInn = (inn: string) => {
  localStorage.setItem(INN_KEY, inn);
};

const setFirstName = (firstName: string) => {
  localStorage.setItem(FIRST_NAME_KEY, firstName);
};

const setLastName = (lastName: string) => {
  localStorage.setItem(LAST_NAME_KEY, lastName);
};

const getToken = () => {
  return localStorage.getItem(TOKEN_KEY) || null;
};

const getInn = () => {
  return localStorage.getItem(INN_KEY) || null;
};

const getFirstName = () => {
  return localStorage.getItem(FIRST_NAME_KEY) || null;
};

const getLastName = () => {
  return localStorage.getItem(LAST_NAME_KEY) || null;
};

const logout = () => {
  localStorage.removeItem(INN_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(FIRST_NAME_KEY);
  localStorage.removeItem(LAST_NAME_KEY);
};

const clearAuthData = () => {

  
  // Очищаем все данные аутентификации
  localStorage.removeItem(INN_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(FIRST_NAME_KEY);
  localStorage.removeItem(LAST_NAME_KEY);
  
  
  
  // Очищаем кэш браузера для API запросов
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
  
    });
  }
  
  // Очищаем sessionStorage если есть
  sessionStorage.clear();
  
  
  // Очищаем кэш axios
  clearApiCache();
  
  
  // Сбрасываем состояние пользователя в контексте
  // Это будет сделано в компоненте

};

export { setToken, getToken, setInn, getInn, setFirstName, setLastName, getFirstName, getLastName, logout, clearAuthData };
